import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { styled } from '@material-ui/core';
import TextBlock from './TextBlock';
import VimeoVideoBlock from './VimeoVideoBlock';
import YouTubeVideoBlock from './YouTubeVideoBlock';
import QuoteBlock from './QuoteBlock';
import FreeImageFullScreen from './FreeImageFullScreen';
import DesignerBlock from './DesignerBlock';
import FreeImageBlock from './FreeImageBlock';
import TechnicalSheetBlock from './TechnicalSheetBlock';
import DetailSlider from './DetailSlider';
import VirtualShowroomBlock from './VirtualShowroomBlock';
import TitleBlock from './TitleBlock';

const StyledContainer = styled('div')({
  cursor: 'unset !important',
});

const dynamicAccordeons = {
  sd_brand_multitext: TextBlock,
  vimeo_video: VimeoVideoBlock,
  youtube_video: YouTubeVideoBlock,
  sdm_quoted_text: QuoteBlock,
  section_title: TitleBlock,
  immagine_libera_full_screen: FreeImageFullScreen,
  designer: DesignerBlock,
  free_image: FreeImageBlock,
  technical_sheet: TechnicalSheetBlock,
  slider_detail: DetailSlider,
  virtual_showroom: VirtualShowroomBlock,
};

const SortableItem = ({
  id,
  name,
  control,
  getValues,
  field,
  idx,
  additionalData,
  handleDelete,
  setValue,
  watch,
  setCustomErrors,
  langCode,
  productLangCode,
  setInfoDialog,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    zIndex: isDragging ? 1 : undefined,
  };

  const Component = dynamicAccordeons[name];

  return (
    <StyledContainer style={{ ...style }} ref={setNodeRef} {...attributes}>
      <Component
        control={control}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        setCustomErrors={setCustomErrors}
        field={field}
        additionalData={additionalData}
        handleDelete={() => handleDelete(field.id)}
        idx={idx}
        langCode={langCode}
        productLangCode={productLangCode}
        setInfoDialog={setInfoDialog}
        {...listeners}
      />
    </StyledContainer>
  );
};

export default SortableItem;
